import React, { useEffect, useState } from 'react'
import { Spinner, TabFilter } from '../common/Helper';

import { useConf, useTicketGrouper } from '../../lib/hooks';
import { IssueGroupView } from '../perf/IssueGroup'; 

const Status = () => {

    
    const { groupedList, filter } = useTicketGrouper()
    const [filters, setFilters] = useState([]);


    const { workflow } = useConf();

    useEffect(() => {
        setFilters(['All', 'Pending', ...workflow]);
    }, [workflow])

    let content = null,
        total = 0;


    if (groupedList == null) {
        content = <Spinner />;
    } else if (groupedList.length === 0) {
        content = <div className="issue-empty">No results to show.</div>;
    } else {
        const views = groupedList.reduce((acc, item) => {
            item.filter(filter);
            acc.push(<IssueGroupView key={item.uname} group={item} filter={filter} />);
            return acc;
        }, []);

        content = <div className="issue-board">{views}</div>;
        total = groupedList.reduce((acc, item) => acc + item.filtered.length, 0);
    }

    return (
        <div>
            <TabFilter filters={filters} name='filter' count={total} />
            <div style={{ marginTop: 'var(--ds-space-5)' }}>
                {content}
            </div>
        </div>
    );

}

export default Status;